import script from "./DropDownTextArea.vue?vue&type=script&setup=true&lang=js"
export * from "./DropDownTextArea.vue?vue&type=script&setup=true&lang=js"

import "./DropDownTextArea.vue?vue&type=style&index=0&id=eb2984a0&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-eb2984a0"]])

export default __exports__